import localforage from 'localforage'

export const drivers = {
    INDEXEDDB: localforage.INDEXEDDB,
    LOCALSTORAGE: localforage.LOCALSTORAGE,
    WEBSQL: localforage.WEBSQL,
}

// Fallback order: prefer localStorage (backward-compatible with existing customer
// data), then IndexedDB, then WebSQL. This ensures Safari private browsing users
// get a working driver instead of an unhandled rejection (CENTAUR-BP3).
const DEFAULT_DRIVERS = [
    localforage.LOCALSTORAGE,
    localforage.INDEXEDDB,
    localforage.WEBSQL,
]

export function createStorage<State>({
    name = '',
    driver = DEFAULT_DRIVERS as string | string[],
}: {
    name?: string
    driver?: string | string[]
} = {}): IStorage {
    const storage = localforage.createInstance({
        name,
        driver,
    })

    return {
        storage,
        saveItem: (key, value) => storage.setItem(key, value),
        getItem: (key: string) => storage.getItem(key),
        removeItem: (key: string) => storage.removeItem(key),
        serialize: () =>
            storage.iterate((state: Partial<State>): Partial<State> => {
                console.log('serialize', state)
                return state
            }),
    } as IStorage
}
